(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentsSettings',
	};

	var hot_list_event_types = [
		'birthday', 'anniversary', 'prior_purchase', 'future_cruise_credit', 'future_cruise_deposit'
	];

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var text_message_fields = [
			'default_cs_text_message',
			'default_rs_text_message',
			'default_hs_text_message',
			'default_tour_text_message',
			'default_bucket_text_message',
			'default_reservation_text_message',
			'default_fb_text_message',
		];

		// SET-137: ONLY INITIALISE A HELPER WHOSE ELEMENT IS ACTUALLY ON THE PAGE.
		//
		// This file assumed the whole 143-field settings screen - true on /Agents/settings and
		// false on every My Settings panel, each of which renders a handful of those fields. The
		// modal re-runs load() after every panel render through Adzuki.Form.initAjaxForm(), so
		// CharacterCount and Typeahead were called against absent elements and logged
		// "cannot find el" roughly nine times per panel open.
		//
		// NOTHING WAS BROKEN BY IT - both helpers log and return. The cost was diagnostic: a
		// console that cries wolf on every panel open is one nobody reads, and two defects on this
		// surface have had a console message as their only early signal.
		//
		// NOT SCOPED TO THE MODAL. The legacy screen renders every field, so a presence check is
		// simply true there and the two surfaces need no branch between them.
		//
		// THE jQuery BINDINGS BELOW NEED NO GUARD. .on(), .click() and .change() against an empty
		// set are silent no-ops by design; it is only these two helpers that report.
		var _ifPresent = function ifPresent(selector, callback) {
			if ($(selector).length === 0) {
				return;
			}

			callback();
		};

		$('input.flight-alert-toggle').on('click', function flightAlertsToggle() {
			var $events = $(this).parents('.form-group').find('.flight-alert-events');
			$events.find('input[type="checkbox"]').prop('disabled', !this.checked);
		});

		// Trip gap travel types belong to Maxx Assist, so they follow its switch.
		//
		// Hidden with a class, never disabled. The flight-alert toggle above
		// disables its checkboxes, which is right there because absent means
		// "no events"; here absent would mean "suggest nothing", and an advisor
		// who turned Maxx Assist off and saved would come back to every type
		// switched off. The form skips the write entirely while it is off, and
		// this keeps the inputs posting either way.
		$('input.maxx-assist-toggle').on('change', function maxxAssistToggle() {
			$('.maxx-assist-gap-types').toggleClass('hidden', !this.checked);
		});

		// show hub menu selections based on menu type selection
		$('#agentssettings-agent-default_menu_type').on('change', function onMenuChange(e) {
			if ($(this).val() === 'hubs') {
				$('.hub-menus').removeClass('hidden');
				$('.maxx-hub-menu-shortcuts').removeClass('hidden');
			} else {
				$('.hub-menus').addClass('hidden');
				$('.maxx-hub-menu-shortcuts').addClass('hidden');
			}
		});

		// checking/unchecking Hot list event types
		$.each(hot_list_event_types, function onEachHLEventType(i, event_type) {
			$('#agentssettings-agent-hot_list_optin_' + event_type + '_items').change(function onItemChange()
			{
				$('#agentssettings-agent-hot_list_send_copy_' + event_type + '_items')
					.prop('checked', this.checked);
			});

			$('#agentssettings-agent-hot_list_send_copy_' + event_type + '_items').change(function onItemChange()
			{
				if (
					this.checked
					&& !$('#agentssettings-agent-hot_list_optin_' + event_type + '_items').prop('checked')
				) {
					$('#agentssettings-agent-hot_list_optin_' + event_type + '_items')
						.prop('checked', true);
				}
			});
		});

		$('#agentssettings-agent-dark_mode').click(function toggleDarkMode() {
			if ($(this).prop('checked') === true) {
				$("body").addClass("theme--dark");
			} else {
				$("body").removeClass("theme--dark");
			}
		});

		_ifPresent('#agentssettings-agent-lp_summary_default_content', function lpSummaryCount() {
			Adzuki.CharacterCount('#agentssettings-agent-lp_summary_default_content', {
				max  : 400,
				label: '#lp-summary-count',
			});
		});

		_ifPresent('#agentssettings-lp_intro_text', function lpIntroCount() {
			Adzuki.CharacterCount('#agentssettings-lp_intro_text', {
				max  : 500,
				label: '#lp-intro-count',
			});
		});

		// show character counts for default text message fields
		$.each(text_message_fields, function eachTextMessageField(i, field) {
			_ifPresent('#agentssettings-agent-' + field, function textMessageCount() {
				Adzuki.CharacterCount('#agentssettings-agent-' + field, {
					max  : 150,
					label: '.' + field + '-count',
				});
			});
		});

		$('#agentssettings-agent-lp_enable_schedule').click(function _showHideLpSchedule() {
			if ($(this).prop('checked') === true) {
				$('.lp-schedule').removeClass('hidden');
			} else {
				$('.lp-schedule').addClass('hidden');
			}
		});

		$('#agentssettings-agent-send_tasks_summary').on('change', function onCheckboxChange(e) {
			if ($(this).prop('checked') === true) {
				$('.tasks-summary-options').removeClass('hidden');
			} else {
				$('.tasks-summary-options').addClass('hidden');
			}
		});

		$('#agentssettings-agent-live_planner_sound_id').on('change', function _onSoundChange(e) {
			var option = $(this).val();

			// hide button to play sound is no sound is selected
			if (!option) {
				$('.play-lp-sound').addClass('hidden');
				return;
			}

			$('.play-lp-sound').removeClass('hidden');
		});

		// clicking on the button to play a sound
		$('.play-lp-sound-btn').on('click', function _onPlayBtnClick(e) {
			var sound_id = $('#agentssettings-agent-live_planner_sound_id').val();

			e.preventDefault();

			if (!sound_id) {
				return;
			}

			$('#lp-sound-' + sound_id).get(0).play();
		});

		$('#agentssettings-agent-send_text_to_opted_in_clients').on('click', function _sentTextsToClients(e) {
			var $self      = $(this),
			    checked    = $self.is(':checked'),
			    $seg_texts = $('#agentssettings-agent-seg_texts');

			$seg_texts.prop('disabled', !checked);

			if (checked === false) {
				$seg_texts.prop("checked", false);
			}
		});


		$('#agentssettings-agent-send_tasks_summary').trigger('change');
		$('#agentssettings-agent-live_planner_sound_id').trigger('change');

		handleFlightAlertFields();

		// SET-39: THE MAXX CREATOR LAYOUT PICKER.
		//
		// THREE TILES AND ONE HIDDEN FIELD. The tiles are the input method; the value that posts is
		// still agent.email_builder_layout_id, so the payload, the validation and process()'s
		// "0 means none" normalisation are all untouched.
		//
		// CLICKING THE CURRENT DEFAULT CLEARS IT, which is why these are buttons and not radios:
		// saving with no default layout is existing behaviour, and a radio group cannot be returned
		// to none once one is chosen.
		//
		// .change() ON THE HIDDEN FIELD IS NOT DECORATION. The modal tracks unsaved edits by
		// listening for change on the panel's inputs, and setting .val() from script fires nothing -
		// so without this the advisor could pick a layout, close the modal and be asked nothing.
		$('.my-settings-layout-tile').on('click', function onLayoutTileClick(e) {
			var $self    = $(this),
			    $field   = $('#agentssettings-agent-email_builder_layout_id'),
			    $grid    = $self.closest('.my-settings-layout-grid'),
			    layout_id = String($self.data('layout-id')),
			    was_default = $self.hasClass('is-default');

			e.preventDefault();

			// every tile back to unselected first, so moving the default off one tile and onto
			// another is one code path rather than two
			$grid.find('.my-settings-layout-tile')
				.removeClass('is-default')
				.attr('aria-pressed', 'false')
				.find('.my-settings-layout-state')
				.text('Set as default');

			if (was_default) {
				$field.val('').change();
				$('.my-settings-layout-none').removeClass('hidden');

				return;
			}

			$self.addClass('is-default')
				.attr('aria-pressed', 'true')
				.find('.my-settings-layout-state')
				.html('Default layout &mdash; click to clear');

			$field.val(layout_id).change();
			$('.my-settings-layout-none').addClass('hidden');
		});

		$('#agentssettings-agent-ask_maxx_enabled').on('change', function onCheckboxChange(e) {
			if ($(this).prop('checked') === true) {
				$('.ask-maxx-topics').removeClass('hidden');
			} else {
				$('.ask-maxx-topics').addClass('hidden');
			}
		});

		// One Maxx Reach switch (2026-09-17): the rest of the Maxx Reach settings only
		// apply while it is on. trigger('change') sets the initial state on page load.
		$('.js-call-list-on-toggle').on('change', function onCallListOnToggle() {
			if ($(this).prop('checked') === true) {
				$('.call-list-subsettings').removeClass('hidden');
			} else {
				$('.call-list-subsettings').addClass('hidden');
			}
		}).trigger('change');

		// Search for a shortcut menu link
		_ifPresent('.shortcut-search-autocomplete', function shortcutSearch() {
		Adzuki.Typeahead(
			'.shortcut-search-autocomplete',
			function search(term, display, $self)
			{
				var _request = Adzuki.Ajax.get('/Shortcuts/autocomplete/' + term);
				_request.then(function searchResults(response)
				{
					display(response);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for shortcut."}]);
				});
			},
			function select(item, $self) {
				if (item.id !== null) {

					Adzuki.Ajax.post(
						'/Shortcuts/saveBookmark/', 
							{
								id: item.id
							}
					)
					.then(function searchResults(response)
					{
						if (response.success) {
							$self.removeClass('ajax-spinner');
							_loadShortCutList();
							Adzuki.StatusMessage('Success', 'You have added ' + response.total + ' of 20 shortcuts');
						} else {
							$self.removeClass('ajax-spinner');
							$('.shortcut-search-autocomplete').val('');
							Adzuki.StatusMessage('Error', response.message);
						}
					})
					.catch(function searchError()
					{
						Adzuki.StatusMessage('Error', 'Unable to remove shortcut.');
					});
				}
			},
			function template(item) {
				return JSON.stringify(item);
			}
		);
		});

		// Remove bookmark
		//
		// SET-55: NAMESPACED, AND off BEFORE on. form.load() runs on every AJAX render of this
		// form, and inside the My Settings modal that is once per panel visit - so a handler
		// delegated from document.body, which survives every render, was stacking up one copy per
		// render. Nothing showed it because .remove-item exists only on the legacy screen; the
		// first modal panel to carry that class would have raised the confirmation N times and
		// posted N deletes. Every other handler in this file binds to an element that is replaced
		// with the form, so the old one goes with it - this was the only one bound to a survivor.
		$(document.body).off('click.agentsSettingsShortcuts');
		$(document.body).on('click.agentsSettingsShortcuts', '.remove-item', function removeBookmark() {
			var $element = $(this);
			var id       = $element.data('section_item_id');

			Adzuki.CustomConfirm({
				body   : 'Are you sure you wish to delete this shortcut?',
				confirm: function agentConfirm() {
					Adzuki.Ajax.post(
						'/Shortcuts/removeBookmark/', 
							{
								id: id
							}
					)
					.then(function saveResults(response)
					{
						if (response.success) {
							_loadShortCutList();
							Adzuki.StatusMessage('Success', 'Shortcut removed.');
						} else {
							Adzuki.StatusMessage('Error', response.message);
						}
					})
					.catch(function saveError()
					{
						Adzuki.StatusMessage('Error', 'Unable to remove shortcut.');
					});
				}
			});
		});
	};

	/**
	 * Displays the list of shortcuts
	 */
	function _loadShortCutList()
	{
		Adzuki.Ajax.get('/Shortcuts/displayShortcuts')
			.then(function populateShortcuts(response) {
				$('.shortcut-container').html(response);
				$('.shortcut-search-autocomplete').val('');
			}
		);
	}

	/**
	 * Displays the checkbox that triggers an update on all flight alerts settings
	 * Sets on change events
	 */
	function handleFlightAlertFields()
	{
		var flight_alert_fields = [
			'flightstats-cancelled',
			'flightstats-departure-delay',
			'flightstats-diverted',
			'flightstats-departure-gate',
			'flightstats-arrival-delay',
			'agent-flightstats_alert_default_agent',
			'agent-flightstats_alert_default_travelers',
		];

		$.each(flight_alert_fields, function setOnChangeEvent(i, field) {
			$('#agentssettings-' + field).change(function change() {
				if ($('#updateAllFlightAlertsSection').hasClass('hidden')) {
					$('#agentssettings-flightstats-update_all').prop('checked', true);
					$('#updateAllFlightAlertsSection').removeClass('hidden');
				}
			});
		});
	}
}(jQuery, window.Adzuki || {}));
